import { render, staticRenderFns } from "./TestimonialsHome.vue?vue&type=template&id=720e904e&scoped=true&"
import script from "./TestimonialsHome.vue?vue&type=script&lang=js&"
export * from "./TestimonialsHome.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialsHome.vue?vue&type=style&index=0&id=720e904e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720e904e",
  null
  
)

export default component.exports